import _ from 'lodash';
import axios from 'axios';
import { buildExpressBulkQuery } from '../queries/builders';
import { renameKey } from '../../../utils';

/**
 * Replacement for batch queries.
 *
 * Abstracts request > response process
 *
 * @param {*} queryFn
 * @param {*} params
 */
const getBulkQueryData = async (queryFn, params) => {
    const newParams = params;
    // Respect caller-provided queryBuilder (e.g. split-gated buildLoopbackQuery).
    // Only default to Express bulk when caller didn't specify one.
    if (!newParams.queryBuilder) {
        newParams.queryBuilder = buildExpressBulkQuery;
    }
    const result = queryFn(newParams);
    // Handle both query shapes: Express bulk returns { url, body } (POST),
    // other builders may return a string URL (GET).
    let response;
    if (typeof result === 'string') {
        response = await axios.get(result);
    } else {
        response = await axios.post(result.url, result.body);
    }
    // Safe normalization: only set id from _id when id is missing.
    // This preserves LoopBack id values while fixing Express _id responses.
    if (Array.isArray(response.data)) {
        response.data.forEach((item) => {
            if (!item) return;
            if ((item.id === undefined || item.id === null) && item._id) {
                // eslint-disable-next-line no-param-reassign
                item.id = item._id;
            }
        });
    }
    return response.data;
};

export default getBulkQueryData;
